import {css, StyleSheet} from 'aphrodite';
import React, {ReactNode} from 'react';

import * as Colors from 'ui-library/Colors';
import FieldLabel from 'ui-library/inputs/FieldLabel';

export default function AnalysisTemplateInputCard({
  children,
  title,
}: {
  children: ReactNode;
  title: JSX.Element | string;
}): JSX.Element {
  return (
    <div className={css(styles.card)}>
      <div className={css(styles.cardHeader)}>
        <FieldLabel className={css(styles.title)} label={title} />
      </div>
      <div className={css(styles.cardBody)}>{children}</div>
    </div>
  );
}

const styles = StyleSheet.create({
  card: {
    background: Colors.BLUE_POWDER_LIGHT,
    border: `1px solid ${Colors.BLUE}`,
    borderRadius: 4,
    padding: 8,
    marginBottom: 4,
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  cardBody: {
    marginLeft: 22,
  },
  title: {
    marginLeft: 6,
    wordBreak: 'break-word',
    flex: 1,
    minWidth: 0,
  },
});
